import { MODAL_ROUTE } from '@/constants';
import { useGetBrandsQuery } from '@/features/slice/products/brand/brand-api-slice';
import { useModal, useUrlFilter, useUrlPagination } from '@/hooks';

export const useBrandList = () => {
    const { debouncedSearchText } = useUrlFilter();
    const { page, limit } = useUrlPagination();
    const { openModal } = useModal();

    const { data, isLoading, isFetching, isError, error } = useGetBrandsQuery({
        page,
        limit,
        search: debouncedSearchText,
        sort_by: 'name',
        sort_order: 'asc',
    });

    const handleCreateBrand = () => {
        openModal(MODAL_ROUTE.CREATE_PRODUCT_BRAND);
    };

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,

        handleCreateBrand,
    };
};
